import { useLanguage } from '@/lib/i18n';
import { motion } from 'framer-motion';

const AboutSection = () => {
  const { lang, tr } = useLanguage();

  const philosophies = [
    { title: tr('about.phil1.title'), desc: tr('about.phil1.desc') },
    { title: tr('about.phil2.title'), desc: tr('about.phil2.desc') },
    { title: tr('about.phil3.title'), desc: tr('about.phil3.desc') },
  ];

  const gvpContent = {
    de: {
      title: 'Mitglied im GVP Gesamtverband der Personaldienstleister',
      text: 'ViaMedica Balkan ist Mitglied im GVP Gesamtverband der Personaldienstleister. Diese Mitgliedschaft unterstreicht unser Bekenntnis zu hohen Qualitatsstandards, fairen Arbeitsbedingungen und verantwortungsvoller Personaldienstleistung in Deutschland.',
      linkLabel: 'Mehr zum GVP',
    },
    bs: {
      title: 'Clan GVP-a (Gesamtverband der Personaldienstleister)',
      text: 'ViaMedica Balkan je clan GVP-a (Gesamtverband der Personaldienstleister). Ovo clanstvo potvrduje nasu posvecenost visokim standardima kvaliteta, fer uslovima rada i odgovornom pruzanju usluga zaposljavanja u Njemackoj.',
      linkLabel: 'Vise o GVP-u',
    },
    en: {
      title: 'Member of GVP (Gesamtverband der Personaldienstleister)',
      text: 'ViaMedica Balkan is a member of GVP (Gesamtverband der Personaldienstleister). This membership reflects our commitment to high quality standards, fair working conditions, and responsible staffing services in Germany.',
      linkLabel: 'Learn more about GVP',
    },
  };

  const gvp = gvpContent[lang] || gvpContent.de;

  return (
    <section id="about" className="scroll-mt-24 py-16 md:py-24 section-gradient">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center max-w-3xl mx-auto mb-14"
        >
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground">{tr('about.title')}</h2>
          <p className="mt-3 font-heading text-xl text-primary font-medium">{tr('about.subtitle')}</p>
          <p className="mt-4 text-muted-foreground text-lg">{tr('about.desc')}</p>
          <p className="mt-6 text-sm text-muted-foreground border-l-4 border-primary pl-3">
            {tr('about.austrojob')}
          </p>

          <div className="mt-6 rounded-xl border border-primary/30 bg-card/70 p-5 text-left shadow-sm">
            <p className="font-semibold text-foreground">{gvp.title}</p>
            <p className="mt-2 text-sm text-muted-foreground">{gvp.text}</p>
            <a
              href="https://www.personaldienstleister.de/"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 inline-block text-sm font-medium text-primary underline underline-offset-4 hover:text-primary/80"
            >
              {gvp.linkLabel}
            </a>
          </div>
        </motion.div>
        <div className="grid md:grid-cols-3 gap-8">
          {philosophies.map((p, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="bg-card rounded-xl p-8 card-shadow border-t-4 border-primary"
            >
              <h4 className="font-heading text-lg font-semibold text-foreground mb-3">{p.title}</h4>
              <p className="text-muted-foreground text-sm leading-relaxed">{p.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;

